export const POST_MASONRY_FORM = '/v1/masonry-form';
export const POST_MASONRY_FLOW_STEP = '/v1/masonry-form-partial';
